import { render, staticRenderFns } from "./CreateCouponPage.vue?vue&type=template&id=b6fa198c"
import script from "./CreateCouponPage.vue?vue&type=script&lang=js"
export * from "./CreateCouponPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports